import React, {PureComponent} from "react"
import PropTypes from "prop-types"
import {connect} from "react-redux"
import scrollIntoView from "scroll-into-view-if-needed"

import {FormattedMessage} from "@irati/utils/lang"
import DealLocationsQueryComponent from "@irati/deals/apollo/query/DealLocations"
import {DEFAULT_RADIUS_METERS} from "@irati/geolocation/src/constants/proximity"
import {hasValidValues} from "@irati/geolocation/src/helpers/latLng"
import {Body, H4} from "@irati/ui/src/Typography"
import {Hr} from "@irati/ui/src/Layout"
import Button from "@irati/ui/src/Button"

import {StyledAddress} from "./styled/NearestLocation"

class NearestLocation extends PureComponent {
  static propTypes = {
    deal: PropTypes.shape({
      uuid: PropTypes.string.isRequired
    }).isRequired,
    userLocation: PropTypes.shape({
      latLng: PropTypes.shape({
        lat: PropTypes.number.isRequired,
        lng: PropTypes.number.isRequired
      })
    }).isRequired
  }

  handleRedemptionLinkClick = () => {
    scrollIntoView(document.getElementById("deal-info__deal-info-block__locations"), {
      scrollMode: "if-needed",
      behavior: "smooth"
    })
  }

  render() {
    const {deal, userLocation: {latLng}} = this.props
    const {lat, lng} = latLng
    const variables = {
      dealId: deal.uuid,
      lat,
      lng,
      radius: DEFAULT_RADIUS_METERS,
      offset: 0,
      limit: 100
    }
    if (!hasValidValues(lat, lng)) { return null }
    return (
      <DealLocationsQueryComponent variables={variables}>
        {({data: {dealLocations}}) => {
          if (!dealLocations.results.length) { return null }
          const {streetAddress, city, postCode} = dealLocations.results[0]
          return (
            <>
              <Hr small />
              <H4>
                <FormattedMessage id="perks.nearestLocation.header" />
              </H4>
              <StyledAddress title={streetAddress} city={city} postCode={postCode} />
              <Body small>
                <FormattedMessage
                  id="perks.nearestLocation.redemption.text"
                  values={{
                    link: (
                      <Button cta onClick={this.handleRedemptionLinkClick}>
                        <FormattedMessage id="perks.nearestLocation.redemption.link.text" />
                      </Button>
                    )
                  }} />
              </Body>
            </>
          )
        }}
      </DealLocationsQueryComponent>
    )
  }
}

const mapStateToProps = ({geoLocation}) => ({userLocation: geoLocation.userLocation})

export default connect(mapStateToProps)(NearestLocation)
